<template>
  <table class="TableContent standard">
    <thead>
      <tr>
        <th v-for="th in table.thead" :key="th._uid">
          {{ th.value }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="tr in table.tbody" :key="tr._uid">
        <td v-for="td in tr.body" :key="td._uid">
          {{ td.value }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup lang="ts">
import { StoryBlokTable } from '#constants/types/storyblok';

defineProps<{
  table: StoryBlokTable,
}>();
</script>
